import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ja';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('ja');

export const formatDateWithWeekday = (date?: Dayjs | Date | string): string => {
    return dayjs(date).format('YYYY/MM/DD(dd)');
};

export const getCurrentDateWithWeekday = (): string => {
    return formatDateWithWeekday();
};

export const formatDate = (dateString?: string): string => {
    if (!dateString) return '-';
    return dayjs(dateString).format('YYYY/MM/DD');
};

export const formatDateTime = (dateTimeString?: string | null): string => {
    if (!dateTimeString) return '-';
    // UTCでパースし、JSTに変換して表示
    return dayjs.utc(dateTimeString).tz('Asia/Tokyo').format('YYYY/MM/DD HH:mm');
};

export const formatTime = (dateTimeString?: string): string => {
    if (!dateTimeString) return '-';
    // UTCでパースし、JSTに変換して表示
    return dayjs.utc(dateTimeString).tz('Asia/Tokyo').format('HH:mm');
};

export const formatDateTimeForFilename = (date?: Dayjs | Date | string): string => {
    return dayjs(date).format('YYYYMMDD_HHmmss');
};
